import React from "react";

const RaindropTextHeading1 = ({ children, className = "" }) => {
  return (
    <p
      className={`text-lg text-left font-black whitespace-nowrap text-color-text-primary dark:text-color-dark-text-primary ${className} `}
    >
      {children}
    </p>
  );
};

export default RaindropTextHeading1;
